import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import message from 'framework/modules/message';
import logger from './logger';
import tcAnalytics from './analytics';
import constants from './constants';
import utility from './utility';
import 'bootstrap-tooltip';
import {
    closeSidebarModal,
    triggerGlobalError,
    triggerPropertyUnavailableError,
} from '../actions/actions';
import nativeAnalytics from './nativeAnalytics';
import threeDSFrame from './threeDS';

const page = {
    dataStorage: {
        scrolling: false,
        history: [],
        skipBackEvent: false,
    },

    hasErrors() {
        return this.getErrors().length > 0;
    },

    rentalAgreementCheckboxStatus(globalError = false) {
        let checked = $('.rental-agreement-checkbox .checkbox').length
            ? $('.rental-agreement-checkbox .checkbox').is(':checked')
            : true;
        if (!checked && globalError) {
            this.dataStorage.store.dispatch(
                triggerGlobalError({
                    response: [
                        {
                            description: message.read(
                                'vas.widgets.rental.agreement.error'
                            ),
                        },
                    ],
                    enableContinue: false,
                    hideMainContent: false,
                    enableAnalytics: false,
                })
            );
            page.scrollToGlobalError();
        }
        return checked;
    },
    dispatchGlobalErrorAction(errorResponse) {
        if (errorResponse) {
            if (document.getElementById('loyalty-prenotification-banner')) {
                page.removeLoyaltyPreNotificationBanner();
            }
            this.dataStorage.store.dispatch(
                triggerGlobalError({
                    response: errorResponse.response || null,
                    enableContinue: errorResponse.enableContinue || false,
                    hideMainContent: errorResponse.hideMainContent || false,
                    enableAnalytics: errorResponse.enableAnalytics || true,
                })
            );
        }
    },

    dispatchPropertyUnavailableError(referrerUrl, options = {}) {
        this.dataStorage.store.dispatch(
            triggerPropertyUnavailableError({
                title: message.read(
                    'traveler.checkout.error.notavailable.heading'
                ),
                description: message.read(
                    'traveler.checkout.error.notavailable.subheading'
                ),
                actionButton: {
                    text: message.read(
                        'traveler.checkout.error.notavailable.cta'
                    ),
                    url: referrerUrl || '/',
                },
                hideMainContent: options.hideMainContent !== false,
                enableAnalytics: options.enableAnalytics !== false,
            })
        );
    },

    // TODO: fix this for the vas panel
    scrollToFirstError(shouldFocus = false) {
        const that = this;
        const phoneViewport = [constants.BOOTSTRAP.EXTRA_SMALL_VIEWPORT];
        const firstTooltipErrorPos = $('.tooltip:visible:first').offset();
        const firstElementError = $('.has-error:visible:first');
        const firstElementErrorPos = firstElementError.offset();

        let tooltipOffset = this.isBootstrapViewportVisible(phoneViewport)
            ? 50
            : 0;
        let topErrorOffsetFlag = true;
        let errors = '';
        let firstError;

        if (!firstTooltipErrorPos) {
            topErrorOffsetFlag = false;
        } else if (firstTooltipErrorPos && firstElementErrorPos) {
            topErrorOffsetFlag =
                firstTooltipErrorPos.top > firstElementErrorPos.top;
        }

        if (tooltipOffset > 0) {
            tooltipOffset += $('#js-quoteStickyHeader').height();
        }

        try {
            errors = this.getErrors();

            if (errors.length > 0) {
                // TRAVCHK-4427 log to edap
                tcAnalytics.logTooltipErrors(errors);
            }

            if (!this.dataStorage.scrolling) {
                this.dataStorage.scrolling = true;
                firstError = topErrorOffsetFlag
                    ? firstTooltipErrorPos
                    : firstElementErrorPos;

                $('html,body').animate(
                    {
                        scrollTop: firstError && firstError.top - tooltipOffset,
                    },
                    1000,
                    () => {
                        that.dataStorage.scrolling = false;

                        if (shouldFocus) {
                            firstElementError.find('.form-control').focus();
                        }
                    }
                );
            }
        } catch (e) {
            logger.log('unable to find error');
        } finally {
            // do not bring in loader.js because this will bring in templates
            // in webpack dependency
            $('body').loading('hide');
        }
    },

    firstErrorProp() {
        let firstProp = $('.has-error > input').data('prop');

        if (_.isUndefined(firstProp)) {
            return 'unknown';
        }

        return firstProp;
    },

    getErrors() {
        let errors = '';
        // js-ignoreError is used to make your error non-blocking.
        $('.tooltip-inner:visible').each((idx, el) => {
            if (!$(el).hasClass('js-ignoreError')) {
                errors += `${$(el).text()};`;
            }
        });

        $('.has-error:visible').each((idx, el) => {
            if (!$(el).hasClass('js-ignoreError')) {
                errors += `${$(el).text()};`;
            }
        });

        return errors;
    },

    getErrorFieldAndMessages() {
        let errorData = [];
        try {
            $('.has-error:visible').each((idx, el) => {
                let value = $(el);
                if (!value.hasClass('js-ignoreError')) {
                    // data-prop is having error_field and error message is taken from span with help-block class
                    errorData.push([
                        `${value.find('input').attr('data-prop')}`,
                        `${value.find('span.help-block').text()}`,
                    ]);
                }
            });
        } catch (e) {
            logger.log(
                'Expected fields, data-prop attribute from input tag and span tag with help-block class, not found'
            );
        }
        return errorData;
    },

    /**
     * adds as tooltip to an element
     *
     * options = {
     *     'ele': the element in which to attach the the tooltip
     *     'hasErrorEle': the element in which to add has-error class
     *     'message': raw translated message
     *     'messageKey': lingua message key
     *     'messageFunction': dynamic function for grabbing title message
     *     'placement': tooltip placement override (bottom, top, right, left)
     *     'mobilePlacement': tooltip mobile placement override (bottom, top, right, left)
     * }
     */
    addTooltip(options) {
        const phoneViewport = [constants.BOOTSTRAP.EXTRA_SMALL_VIEWPORT];
        const tooltipPlacement = this.isBootstrapViewportVisible(phoneViewport)
            ? 'bottom'
            : 'top';
        const data = {
            trigger: 'manual',
            animation: false,
            placement: tooltipPlacement,
        };

        // validate there is an ele provided
        if (_.isUndefined(options.ele)) {
            return false;
        }

        // add class 'has-error' to the hasErrorEle DOM element
        if (!_.isUndefined(options.hasErrorEle)) {
            if (
                options.isNotFormGroup &&
                !options.hasErrorEle.hasClass('form-group')
            ) {
                options.hasErrorEle
                    .closest('.form-group')
                    .addClass('has-error');
            } else {
                options.hasErrorEle.addClass('has-error');
            }
        }

        // if a placement is provided, override default unless mobile device
        if (
            !_.isUndefined(options.placement) &&
            !this.isBootstrapViewportVisible(phoneViewport)
        ) {
            data.placement = options.placement;
        }

        // override for mobile placement
        if (!_.isUndefined(options.mobilePlacement)) {
            data.placement = options.mobilePlacement;
        }

        // set tooltip title
        if (!_.isUndefined(options.messageKey)) {
            data.title = message.read(options.messageKey);
        } else if (_.isFunction(options.messageFunction)) {
            data.title = options.messageFunction;
        } else if (!_.isUndefined(options.message)) {
            data.title = options.message;
        }

        options.ele.addClass('js-hasToolTip');
        options.ele.tooltip(data).tooltip('show');

        return true;
    },

    /**
     * remove the tooltip attached to the provided element
     *
     * options = {
     *     'ele': the element in which the tooltip is attached
     *     'destroy': determines whether or not to just hide the tooltip or remove it from the DOM
     * }
     */
    removeTooltip(options) {
        const destroy = options.destroy ? 'destroy' : 'hide';

        if (_.isUndefined(options.ele)) {
            return false;
        }

        options.ele.removeClass('js-hasToolTip');
        options.ele
            .tooltip(destroy)
            .parents('.has-error')
            .removeClass('has-error');

        return true;
    },

    scrollTo(position, animate) {
        $('html,body').animate(
            {
                scrollTop: position,
            },
            animate
        );
    },

    scrollTop() {
        this.scrollTo(0, 0);
    },

    scrollToGlobalError() {
        let errorTop = $('#tc-global-error').offset().top;
        const jsQuoteStickyHeader = $('#js-quoteStickyHeader');

        errorTop -= jsQuoteStickyHeader.outerHeight();

        $('html,body').animate(
            {
                scrollTop: errorTop,
            },
            1000
        );
    },

    scrollToErrorBanner() {
        const targetElement = document.querySelector('.global-error-alert');

        if (targetElement) {
            targetElement.scrollIntoView({behavior: 'smooth'});
        }
    },

    getWindowObject() {
        return window;
    },

    isBootstrapViewportVisible(viewportTypes) {
        const ele = $(`<span class="${viewportTypes.join(' ')}"></span>`);
        let result = false;

        ele.appendTo('#checkout');

        if (!ele.is(':hidden')) {
            result = true;
        }

        ele.remove();

        return result;
    },

    removeModal() {
        $('.modal').modal('hide');
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('modal-open');

        if (document.getElementById('login-module')) {
            ReactDOM.unmountComponentAtNode(
                document.getElementById('login-module')
            );
        }
    },

    removeLoyaltyPreNotificationBanner() {
        ReactDOM.unmountComponentAtNode(
            document.getElementById('loyalty-prenotification-banner')
        );
    },

    /**
     * Handles all events for window.onhashchange
     * Closes all modal windows if the previous url has the hash of #modal-open
     */
    handleOnHashChange(e) {
        if (e.oldURL.indexOf(constants.PAGE.MODAL_OPEN_HASH) !== -1) {
            page.removeModal();
        }
        if (e.oldURL.indexOf(constants.PAGE.SIDEBAR_MODAL_OPEN_HASH) !== -1) {
            this.dataStorage.store.dispatch(closeSidebarModal());
        }

        if (e.oldURL.indexOf(constants.PAGE.QUOTE_DETAILS_OPEN) !== -1) {
            this.dataStorage.store.dispatch(closeSidebarModal());
        }

        if (e.oldURL.indexOf(constants.PAGE.AFFIRM_LEARNMORE_OPEN) !== -1) {
            affirm?.ui?.modal?.close(); // eslint-disable-line no-undef
        }
    },

    isSidebarModalOpen() {
        const getState = _.get(this.dataStorage, 'store.getState');
        return _.get(getState && getState(), 'modals.sidebarModal', false);
    },

    /**
     * Handles navigation for abacus test HA_CKO_SteppedCheckout
     */
    async handleSteppedCheckoutNavigation() {
        if (this.dataStorage.skipBackEvent) {
            this.dataStorage.skipBackEvent = false;
        } else if (
            this.dataStorage.history.length > 1 ||
            this.isSidebarModalOpen()
        ) {
            // Pop off the old page and grab the next page for pushing state
            // Always pushing state on back navigation disables the forward button
            const prevPage = this.dataStorage.history.pop();
            const panel =
                this.dataStorage.history[this.dataStorage.history.length - 1];
            const STEPPED_CHECKOUT = constants.PAGE.STEPPED_CHECKOUT;

            if (
                // Was affirm modal open when back navigation clicked?
                Object.keys(window.affirm?.checkout?.data?.items || {}).length
            ) {
                window.location.reload();
            }

            if (prevPage === constants.PAGE.SIDEBAR_MODAL_OPEN_HASH) {
                this.dataStorage.store.dispatch(closeSidebarModal());
            }

            if (prevPage === constants.PAGE.MODAL_OPEN_HASH) {
                page.removeModal();
            }

            if (prevPage === constants.PAGE.THREEDS_MODAL_OPEN_HASH) {
                // if 3DS frame is presenting challenge and cancel payment button is pressed, clean up booking
                await threeDSFrame.cleanUpBooking();
                page.removePaymentError();
                page.addPaymentError(message.read('threeds.error'));
                page.scrollTop();
            }

            // Match the same EDAP events that are fired when clicking the back link in checkout-step.js
            // Only fire if prevPage was a checkout step
            if (STEPPED_CHECKOUT.EVENTS[prevPage]) {
                const eventNamespace =
                    STEPPED_CHECKOUT.HASH_NAMESPACE[prevPage];
                nativeAnalytics.trackEvent(
                    `Tap Checkout ${eventNamespace} Back`
                );
                tcAnalytics.genericEvent(
                    `Click Checkout ${eventNamespace} Back`
                );
            }

            // This will only hide bootstrap popovers
            if ($('.popover')[0]) {
                $('.popover').popover('hide');
            }

            if (panel) {
                // TODO: remove when payment gets converted to use checkout-step
                if (
                    STEPPED_CHECKOUT.EVENTS[panel] &&
                    panel !== STEPPED_CHECKOUT.PAYMENT
                ) {
                    // this event only hides the payment panel
                    Backbone.trigger(constants.EVENTS.HIDE_PAYMENT);
                    page.removePaymentError();
                }

                Backbone.trigger(STEPPED_CHECKOUT.EVENTS[panel]);

                if (history.pushState && history.replaceState) {
                    if (utility.isNativeMobileRequest()) {
                        // For native mobile, there is no browser forward button so we want to treat this as a normal flow
                        // This is essentially the opposite of page.addWindowHash()
                        history.replaceState(
                            this.dataStorage.history,
                            panel,
                            panel
                        );
                    } else {
                        // pushState to micromanage and disable the browser forward button
                        history.pushState(
                            this.dataStorage.history,
                            panel,
                            panel
                        );
                    }
                } else {
                    location.hash = panel;
                }
            }
        } else if (this.dataStorage.history.length === 1) {
            console.log(`history = ${this.dataStorage.history[0]}`);
            // They're trying to navigate off checkout page, go back 1 more time to pop off init push state
            if (history.length < 3) {
                if (utility.isNativeMobileRequest()) {
                    // For android webview, we need to go back from webview to the app. Androids will know when to go back when there are no more items in history
                    // For iOS webview, there's a back to PDP button
                    history.back();
                    return;
                } else if (history.pushState) {
                    // CHK-5406 If history length is 2, there is nothing to go back to (ie, traveler opened a link from
                    // another source, or with a cmd+click). We need to maintain the 2nd push state as if they never
                    // clicked on the back button (not a great user experience, but we don't have an alternative)
                    logger.log('ignored user back button');
                    history.pushState(
                        this.dataStorage.history,
                        this.dataStorage.history[0],
                        this.dataStorage.history[0]
                    );
                }
            } else if (!window.affirm?.ui?.modal?.hidden) {
                window.affirm.ui.modal.close();
                history.pushState(
                    this.dataStorage.history,
                    this.dataStorage.history[0],
                    this.dataStorage.history[0]
                );
            } else if (history.go) {
                history.go(-1);
            }
        }
    },

    /**
     * TRAVCHK-4704
     *
     * Description:
     * this function attachs a window hash listener for determining when to close a modal if
     * the user had previously opened a modal.  this function is primarily for android devices
     * when the user opens a modal and presses the back button to close the modal
     */
    attachWindowHashChange() {
        window.onhashchange = this.handleOnHashChange.bind(this);
    },

    /**
     * Set up internal management of browser history. For stepped checkout, we use only 2 states for browser history:
     * one when we get for free when we initially hit the page, and a 2nd that gets pushed when step 1 for step 1 in
     * this function. We reuse the 2nd state whenever a forward navigation happens (such as clicking continue or
     * opening a modal). When a user presses back, we go back to the initial state and then immediately push a new state
     * to replace the existing 2nd one. This allows us to disable the forward button.
     */
    initHistory(hash) {
        if (history.pushState && !utility.isChromeiOS()) {
            if (this.dataStorage.history.length === 0) {
                if (history.scrollRestoration) {
                    // "manual" or "auto". Manual will prevent scrolling to the top of the page for onpopstate events
                    history.scrollRestoration = 'manual';
                }

                this.dataStorage.history.push(hash);

                if (utility.isNativeMobileRequest()) {
                    // For native mobile, there is no browser forward button so we want to treat this as a normal flow
                    history.replaceState(this.dataStorage.history, hash, hash);
                } else {
                    // pushState to micromanage and disable the browser forward button
                    history.pushState(this.dataStorage.history, hash, hash);
                }

                window.onpopstate =
                    this.handleSteppedCheckoutNavigation.bind(this);
            }
        } else {
            this.attachWindowHashChange();
        }
    },
    initStore(store) {
        // Check if the store already exists or assign the new store
        this.dataStorage.store = this.dataStorage.store || store;
    },

    /**
     * This is used to reset the internal management of browser history after a user changes dates/guest selection
     */
    resetHistory(checkoutUrl) {
        if (
            history.go &&
            history.replaceState &&
            history.pushState &&
            !utility.isChromeiOS()
        ) {
            // Go back to first node, replaceState with new url, then push new step1 state
            this.dataStorage.skipBackEvent = true;
            window.onpopstate = () => {
                history.pushState({}, document.title, checkoutUrl);

                // Check if most recent history is the detail modal since it doesn't close on date change and push new node
                const firstPage = this.dataStorage.history[0];
                this.dataStorage.history = [firstPage];

                // If sidebar modal open, we know this is a guest/date change from mobile view
                if (this.isSidebarModalOpen()) {
                    const sidebarModalOpen =
                        constants.PAGE.SIDEBAR_MODAL_OPEN_HASH;
                    this.dataStorage.history.push(sidebarModalOpen);
                    history.pushState(
                        this.dataStorage.history,
                        sidebarModalOpen,
                        sidebarModalOpen
                    );
                } else {
                    history.pushState(
                        this.dataStorage.history,
                        firstPage,
                        firstPage
                    );
                }

                // Reload entire checkout to take care of rerendering data that relies on checkout model
                window.location.reload();
            };
            history.back();
        } else {
            history.pushState({}, document.title, checkoutUrl);
            window.location.reload();
        }
    },

    /**
     * adds a hash to the browser's history
     * @param {string} hash hash value to add to browser history
     */
    addWindowHash(hash) {
        if (history.replaceState && !utility.isChromeiOS()) {
            this.dataStorage.history.push(hash);
            if (!window.onhashchange) {
                this.attachWindowHashChange();
            }
            if (utility.isNativeMobileRequest()) {
                // For native mobile, there is no browser forward button so we want to treat this as a normal flow
                history.pushState(this.dataStorage.history, hash, hash);
            } else {
                // Replace state instead of push state to micromanage forward button
                history.replaceState(this.dataStorage.history, hash, hash);
            }
        } else {
            location.hash = hash;
        }
    },

    /**
     * Event handler for when a user presses the "enter" key or the "go" button an mobile
     * devices, checkout will then "submit" the form
     * @param  {event} e          the event
     * @param  {string} triggerID triggerID from constants file
     */
    submitForm(e, triggerID) {
        let ele;

        if (_.isUndefined(e)) {
            return;
        }

        ele = $(e.currentTarget);

        if (e.keyCode === 13 || e.type === constants.INPUT_TYPE.SUBMIT) {
            // blur the field to prevent blowing away error tooltips
            // after form is submitted
            ele.blur();

            // trigger the event to fire off cta processing
            Backbone.trigger(triggerID);

            e.preventDefault();
            e.stopPropagation();
        }
    },

    /**
     * helper method to calculate the positioning of top when positioning of aboslute
     * @return {ing} top position in px for sidebar container
     */
    calculateAffixBottomTop() {
        const sidebar = $('#sidebar');
        const positionContainer = $('.position-container');
        const mainContentContainerHeight = $(
            '.main-content-container'
        ).height();
        const positionContainerHeight = positionContainer.height();
        const affixBottomTop =
            mainContentContainerHeight -
            (positionContainerHeight + parseInt(sidebar.css('marginTop'), 10));

        return affixBottomTop;
    },

    /**
     * recalculate top position based on height of the sidebar
     * this prevents the sidebar from hiding behind the footer
     */
    recalculateSideBarAffixBottom() {
        const positionContainer = $('.position-container');
        const affixBottomTop = this.calculateAffixBottomTop();

        if (positionContainer.hasClass('affix-bottom')) {
            if (affixBottomTop > 0) {
                positionContainer.css({
                    top: `${affixBottomTop}px`,
                });
            } else {
                positionContainer
                    .removeClass('affix-bottom')
                    .removeAttr('style');
            }
        }
    },

    headerScroll() {
        const windowEle = page.getWindowObject();
        const scrollTop = $(windowEle).scrollTop();
        const detailsContainer = $('.quote-sticky-header-details');
        const quoteStickyHeader = $('#js-quoteStickyHeader');
        const isHidden = detailsContainer.is(':hidden');
        const hideOnStickScroll = $('.js-hideOnStickScroll');

        if (!this.touchstart) {
            if (scrollTop > this.offsetTop) {
                quoteStickyHeader.addClass('affix');
                hideOnStickScroll.hide();
            } else if (isHidden) {
                quoteStickyHeader.removeClass('affix');
                hideOnStickScroll.show();
            }
        }
    },

    headerTouchScroll() {
        const windowEle = page.getWindowObject();
        const detailsContainer = $('.quote-sticky-header-details');
        const quoteStickyHeader = $('#js-quoteStickyHeader');
        const contentContainer = $('.js-contentContainer');
        const quoteStickyHeaderHeight = quoteStickyHeader.outerHeight();
        const hideOnStickScroll = $('.js-hideOnStickScroll');
        const that = this;

        this.touchstart = true;
        clearInterval(this.intervalID);
        this.intervalID = setInterval(() => {
            const scrollTop = $(windowEle).scrollTop();
            const isHidden = detailsContainer.is(':hidden');

            if (scrollTop > that.offsetTop) {
                if (!quoteStickyHeader.hasClass('affix')) {
                    quoteStickyHeader.addClass('affix');
                    contentContainer.css({
                        'padding-top': `${quoteStickyHeaderHeight}px`,
                    });
                    hideOnStickScroll.hide();
                }
            } else if (isHidden) {
                quoteStickyHeader.removeClass('affix');
                contentContainer.removeAttr('style');
                hideOnStickScroll.show();
            }
        }, 10);
    },

    /**
     * adds or removes a class from an array of elements
     * @param  {DOMElements} eles      array of eles in which to toggle a class
     * @param  {String} className      name of a CSS class to toggle
     */
    toggleClass(eles, className) {
        if (!_.isString(className) || _.isEmpty(eles)) {
            return;
        }
        _.each(eles, (ele) => {
            ele.toggleClass(className);
        });
    },

    /**
     * determines whether or not the user is online and presents a message if he or she is not
     */
    isOnline(obj) {
        if (
            utility.isNativeMobileRequest() &&
            obj.navigator &&
            !obj.navigator.onLine
        ) {
            $('#offlineModal').modal('show');
            return false;
        }
        return true;
    },

    /**
     * Native js implementation of jQuery scrollTop()
     */
    getScrollTop() {
        return !_.isUndefined(window.pageYOffset)
            ? window.pageYOffset
            : (
                  document.documentElement ||
                  document.body.parentNode ||
                  document.body
              ).scrollTop;
    },

    removePaymentError() {
        $('.is-last-step').removeClass('no-margin-top');
        Backbone.trigger(constants.EVENTS.REMOVE_PAYMENT_ERROR);
    },

    addPaymentError({msg}) {
        $('.is-last-step').addClass('no-margin-top');
        Backbone.trigger(constants.EVENTS.PAYMENT_ERROR, {msg});
    },

    addHashToAffirmLearnMorePopup($container) {
        if ($container) {
            $container.addEventListener('click', function (e) {
                let affirmLearnMoreLinks = document.getElementsByClassName(
                    'affirm-modal-trigger'
                );

                let isAffirmLearnMoreClicked = false;
                if (affirmLearnMoreLinks) {
                    for (let i = 0; i < affirmLearnMoreLinks.length; i++) {
                        isAffirmLearnMoreClicked =
                            affirmLearnMoreLinks[i].firstChild === e?.target ||
                            affirmLearnMoreLinks[i].firstChild ===
                                e?.target.firstChild;
                    }
                }

                if (isAffirmLearnMoreClicked) {
                    page.addWindowHash(constants.PAGE.AFFIRM_LEARNMORE_OPEN);
                }
            });
        }
    },

    rebindSteppedNavigationOnPopState() {
        window.onpopstate = this.handleSteppedCheckoutNavigation.bind(this);
    },
};

export default page;
